import styled from "styled-components";

const ManualInputCard = styled.div`
  background-color: ${({ theme }) => theme.colors.baseWhite};
  padding: 32px;
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: ${({ theme }) => theme.borderRadiusChecklistCard};

  display: grid;
  grid-auto-rows: auto;
  gap: 16px;
`;

export default ManualInputCard;
